module.exports = __webpack_public_path__ + "static/media/menu-live-video-icon.a64a2434.svg";